import { render, staticRenderFns } from "./basket-form-comments.vue?vue&type=template&id=1678382b"
import script from "./basket-form-comments.vue?vue&type=script&lang=js"
export * from "./basket-form-comments.vue?vue&type=script&lang=js"
import style0 from "./basket-form-comments.vue?vue&type=style&index=0&id=1678382b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VCol,VRow,VTextarea})
